import { Stack } from '@mui/material';

import Checkbox from '../../checkbox/Checkbox';
import { MenuItem } from '../SharedStyledComponents';
import type { DownshiftItemProps } from '../types';

type SelectAllItemProps = {
  index: number;
  isChecked: boolean;
  isIndeterminate: boolean;
  showCheckbox: boolean;
  itemProps: DownshiftItemProps;
};

/**
 * Component for rendering the "Select All" menu item
 */
export const SelectAllItem = ({
  index,
  isChecked,
  isIndeterminate,
  showCheckbox,
  itemProps,
}: SelectAllItemProps) => (
  <MenuItem
    data-testid={`option-item-${index}`}
    data-selected={isChecked}
    isDisabled={false}
    isHighlighted={itemProps['aria-selected']}
    isSelected={isChecked}
    key={itemProps.id}
    {...itemProps}
  >
    <Stack
      data-testid="select-all-item"
      direction="row"
      alignItems="center"
      gap="8px"
    >
      {showCheckbox && (
        <Checkbox checked={isChecked} indeterminate={isIndeterminate} />
      )}
      Select All
    </Stack>
  </MenuItem>
);
